import React from 'react';

import { Container } from '../../styles/GlobalStyles';
import history from '../../services/history';

export default function Page404() {
  return (
    <Container>
      <h1>Essa Página não existe</h1>
    </Container>
  );
}
